<div>
	<p class="text">Esta vista es unicamente para prueba de modulos</p>
</div>
